import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/TradesPersonRegisterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
